export class UserDistributionPermissionRevoked extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, UserDistributionPermissionRevoked.prototype)
  }
}
